<div class="process-dashboard-container">
  
  <!-- Header del Dashboard -->
  <div class="process-dashboard-header">
    <h2 class="process-title">Dashboard - {{ processMetrics?.ProcessName || 'Proceso' }}</h2>
    <div class="process-id">ID: {{ processMetrics?.ProcessExecutionId }}</div>
    <div class="process-version">Versión: {{ processMetrics?.ProcessVersion || '0' }}</div>
    <div class="process-created-by">Creado por: {{ processMetrics?.CreatedBy || 'Sistema' }}</div>
  </div>

  <!-- Métricas Principales -->
  <div class="process-metrics-section">
    <div class="process-metrics-grid">
      
      <!-- Estado del Proceso -->
      <div class="process-metric-card" [ngClass]="getStatusClass()">
        <div class="metric-icon">📊</div>
        <div class="metric-content">
          <div class="metric-value">{{ getStatusDisplayText() }}</div>
          <div class="metric-label">Estado</div>
        </div>
      </div>

      <!-- Tiempo de Ejecución -->
      <div class="process-metric-card execution-time">
        <div class="metric-icon">⏱️</div>
        <div class="metric-content">
          <div class="metric-value">{{ getExecutionTimeDisplay() }}</div>
          <div class="metric-label">Tiempo de Ejecución</div>
        </div>
      </div>

      <!-- Total de Tareas -->
      <div class="process-metric-card total-tasks">
        <div class="metric-icon">📋</div>
        <div class="metric-content">
          <div class="metric-value">{{ getTotalTasksDisplay() }}</div>
          <div class="metric-label">Tareas</div>
        </div>
      </div>

    </div>

    <!-- Resumen y Consejos -->
    <div class="process-summary-section">
      <div class="summary-card">
        <strong>Resumen:</strong> {{ getProcessSummary() }}
      </div>
      <div class="insight-card">
        <strong>Estado:</strong> {{ getProcessInsight() }}
      </div>
    </div>
  </div>

  <!-- Gráficos -->
  <div class="process-charts-section" *ngIf="shouldShowProgressChart() || shouldShowTasksChart()">
    <div class="process-charts-grid">
      
      <!-- Gráfico de Progreso -->
      <div class="process-chart-card" *ngIf="shouldShowProgressChart()">
        <apx-chart
          [series]="progressChartOptions.series"
          [chart]="progressChartOptions.chart"
          [plotOptions]="progressChartOptions.plotOptions"
          [colors]="progressChartOptions.colors"
          [stroke]="progressChartOptions.stroke">
        </apx-chart>
        <div class="chart-title">Progreso del Proceso</div>
      </div>

      <!-- Gráfico de Tareas -->
      <div class="process-chart-card" *ngIf="shouldShowTasksChart()">
        <apx-chart
          [series]="tasksChartOptions.series"
          [chart]="tasksChartOptions.chart"
          [plotOptions]="tasksChartOptions.plotOptions"
          [dataLabels]="tasksChartOptions.dataLabels"
          [colors]="tasksChartOptions.colors"
          [xaxis]="tasksChartOptions.xaxis"
          [yaxis]="tasksChartOptions.yaxis"
          [grid]="tasksChartOptions.grid"
          [legend]="tasksChartOptions.legend">
        </apx-chart>
        <div class="chart-title">Estado de Tareas</div>
      </div>

    </div>
  </div>

  <!-- Detalles del Proceso -->
  <div class="process-details-section">
    <h3 class="section-title">Detalles del Proceso</h3>
    <div class="process-details-grid">
      
      <div class="detail-item">
        <span class="detail-label">Tareas Completadas:</span>
        <span class="detail-value">{{ processMetrics?.CompletedTasks || 0 }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">Tareas Pendientes:</span>
        <span class="detail-value">{{ processMetrics?.PendingTasks || 0 }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">Tareas Fallidas:</span>
        <span class="detail-value">{{ processMetrics?.FailedTasks || 0 }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">Tiempo de Ejecución:</span>
        <span class="detail-value">{{ processMetrics?.ExecutionTimeHours || 0 | number:'1.1-1' }}h</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">Progreso:</span>
        <span class="detail-value">{{ processMetrics?.ProgressPercentage || 0 | number:'1.1-1' }}%</span>
      </div>

      <div class="detail-item" *ngIf="processMetrics?.StartDate">
        <span class="detail-label">Fecha de Inicio:</span>
        <span class="detail-value">{{ formatDate(processMetrics.StartDate) }}</span>
      </div>

      <div class="detail-item" *ngIf="processMetrics?.EndDate">
        <span class="detail-label">Fecha de Fin:</span>
        <span class="detail-value">{{ formatDate(processMetrics.EndDate) }}</span>
      </div>

    </div>
  </div>

</div>
